import { Landmark, Sprout, BadgeCheck } from "lucide-react";

const themes = [
  { Icon: Landmark, color: "bg-blue-50 text-blue-700 ring-blue-200/70", name: "public-contracts" },
  { Icon: Sprout, color: "bg-emerald-50 text-emerald-700 ring-emerald-200/70", name: "sustainable-engineering" },
  { Icon: BadgeCheck, color: "bg-amber-50 text-amber-700 ring-amber-200/70", name: "cam-materials" },
];

export const MacroareaIcon = ({ item, index }) => {
  const title = `${item.id || ""} ${item.title} ${item.badge}`;
  const themeIndex = /\bcam\b/i.test(title) ? 2 : /bim|ingegneria|innovazione/i.test(title) ? 1 : /appalti|soa/i.test(title) ? 0 : index % themes.length;
  const { Icon, color, name } = themes[themeIndex];
  return <span aria-hidden="true" data-testid={`macroarea-icon-${index}`} data-theme={name} className={`inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-lg ring-1 ${color}`}>
    <Icon className="h-6 w-6" strokeWidth={1.8} />
  </span>;
};